import { ApplicantService } from '../../services/applicant.service';
import { KanbanSliderCvContractComponent } from '../kanban-slider-cv-contract/kanban-slider-cv-contract.component';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MdDialog, MdDialogRef } from '@angular/material';
import { ViewCvComponent} from '../view-cv/view-cv.component';
import { KanbanSliderCvComponent } from '../kanban-slider-cv/kanban-slider-cv.component';
import { JobsOffersApplicant } from '../../models/jobs-offers-applicant'
import { Constants } from '../constants';

@Component({
  selector: 'app-item-candidate',
  templateUrl: './item-candidate.component.html',
  styleUrls: ['./item-candidate.component.css']
})
export class ItemCandidateComponent implements OnInit {
  @Input() user;
  @Input() index;
  @Input() check_mandatory;
  @Input() job;
  @Input() job2;
  @Input() listtype;
  @Input() contract;
  @Input() isreport;
  @Input() feedback;
  role: string;
  selectedOption;

  public STATUS = Constants;

  constructor(public dialog: MdDialog, public applicantService: ApplicantService) {
    if (this.check_mandatory != undefined) {
      this.check_mandatory = true;
    }
     this.role = localStorage.getItem('role');

  }

  ngOnInit() {
  }

  remove (user) {
    console.log(user);
    if (this.role === 'contracts') {
      this.applicantService.putApplicantContract(this.job.id, user.user_id, -1, this.feedback).subscribe(
        data => {
        },
        error => {
          console.log (error);
        }
      );
    }else {
      this.applicantService.putApplicantStatus(this.job.id, user.user_id, -1, this.feedback).subscribe(
        data => {
        },
        error => {
          console.log (error);
        }
      );
    }
  }

  openCV(userId){
    if (this.job.status !== -4) {
      if (this.contract == "0"){
        let dialogRef = this.dialog.open(KanbanSliderCvComponent, {
          data: {
            selected: userId,
            isreport: this.isreport,
            requirement: false,
            jobInvite: this.job.id,
            listType: this.listtype,
            status: this.user.status.id,
            contract: 1,
            filters: []
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          this.selectedOption = result;
        });
      }else{
        let dialogRef = this.dialog.open(KanbanSliderCvContractComponent, {
          data: {
            selected: userId,
            isreport: this.isreport,
            requirement: false,
            jobInvite: this.job.id,
            listType: this.listtype,
            contract: 0,
            status: this.user.status.id,
            filters: []
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          this.selectedOption = result;
        });
      }

    }
  }

  //noinspection JSMethodCanBeStatic
  percMandatory(user): number {
    if (user.apply != undefined) {
      if(user.apply.mandatoryrequirements > 0) {
        return Math.floor(user.apply.mandatoryrequirementsmet / user.apply.mandatoryrequirements * 100);
      } else {
        return 0;
      }
    } else {
      if(user.mandatoryrequirements > 0) {
        return Math.floor(user.mandatoryrequirementsmet / user.mandatoryrequirements * 100);
      } else {
        return 0;
      }
    }
  }

  //noinspection JSMethodCanBeStatic
  percDesirable(user): number {
    if (user.apply != undefined) {
      if(user.apply.desirablerequirements > 0) {
        return Math.floor(user.apply.desirablerequirementsmet / user.apply.desirablerequirements * 100);
      } else {
        return 0;
      }
    } else {
      if(user.desirablerequirements > 0) {
        return Math.floor(user.desirablerequirementsmet / user.desirablerequirements * 100);
      } else {
        return 0;
      }
    }
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/item-candidate/item-candidate.component.ts